module.exports = __webpack_public_path__ + "pc/img/award2021_03.447b02df.webp";